import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import MySliceReducer from './Slice';

const persistConfig = {
  key: 'root_v2',
  storage,
};

const persistedReducer = persistReducer(persistConfig, MySliceReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

